import { defineMessages } from 'react-intl';

export default defineMessages({
    directDebit: {
        id: '_.your_company.payment_details.direct_debit',
        defaultMessage: 'Lastschriftverfahren'
    },
    automaticRepayment: {
        id: '_.your_company.payment_details.automatic_repayment',
        defaultMessage: 'Automatic repayments'
    },
    edit: {
        id: '_.your_company.payment_details.edit',
        defaultMessage: 'Edit'
    }
});
